"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProductInfo = require("./ProductInfo");
Object.keys(_ProductInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductInfo[key];
    }
  });
});
var _IconButtons = require("./IconButtons");
Object.keys(_IconButtons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IconButtons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _IconButtons[key];
    }
  });
});
//# sourceMappingURL=index.js.map